<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title" translate>Inscription</h4>
  <button type="button" class="btn-modal-close" aria-label="Close" (click)="closeModal()">
    <span class="material-icons-outlined">close</span>
  </button>
</div>
<div class="modal-body">

  <div class="modal-signup-notice">
    <span class="material-icons">shield</span>
    <span>Nous générons aléatoirement un identifiant pour préserver ton anonymat. Mémorise simplement ce login et ton mot de passe pour accéder à tes résultats ultérieurement.</span>
  </div>

  <form [formGroup]="form">

    <div class="mb-3">
      <label class="form-label text-primary fw-bold" for="password" translate>Mot de passe</label>
      <input type="password" id="password" formControlName="password" class="form-control">
    </div>

    <div class="mb-4">
      <label class="form-label text-primary fw-bold" for="passwordConfirm" translate>Confirmation mot de passe</label>
      <input type="password" id="passwordConfirm" formControlName="passwordConfirm" class="form-control" (change)="samePassword()">
      <span class="badge bg-danger mt-2" *ngIf="errorConfirmPassword">La confirmation doit être identique au mot de passe.</span>
    </div>

    <button type="submit" class="btn btn-info text-white fw-semibold px-4 rounded-pill w-100" [disabled]="formIsInvalid()" (click)="submit()" translate>
      S'inscrire
    </button>

  </form>
</div>
